"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var Feature_1 = __importDefault(require("./Feature"));
var Envelope_1 = __importDefault(require("./Envelope"));
var Constants_1 = __importDefault(require("../shared/Constants"));
var FeatureCollection = /** @class */ (function () {
    function FeatureCollection(features, id) {
        var _this = this;
        this.id = 0;
        this.features = new Array();
        this.type = Constants_1.default.TYPE_FEATURE_COLLECTION;
        if (id !== undefined)
            this.id = id;
        if (features === undefined)
            return;
        features.forEach(function (f) { return _this.features.push(Feature_1.default.create(f)); });
    }
    FeatureCollection.prototype.envelope = function () {
        return Envelope_1.default.unionAll(this.features.map(function (f) { return f.envelope(); }));
    };
    FeatureCollection.prototype.toJSON = function () {
        return {
            id: this.id,
            type: this.type,
            features: this.features.map(function (f) { return f.toJSON(); })
        };
    };
    /**
     *
     * @deprecated This method is deprecated. Please use parseJSON() instead.
     */
    FeatureCollection.create = function (json) {
        if (json.type !== Constants_1.default.TYPE_FEATURE_COLLECTION) {
            throw new Error('Not a FeatureCollection json.');
        }
        if (json.features === undefined) {
            throw new Error('Invalid FeatureCollection json.');
        }
        var features = json.features.map(function (f) { return Feature_1.default.create(f); });
        return new FeatureCollection(features, json.id);
    };
    FeatureCollection.parseJSON = function (json) {
        if (json.type !== Constants_1.default.TYPE_FEATURE_COLLECTION) {
            throw new Error('Not a FeatureCollection json.');
        }
        if (json.features === undefined) {
            throw new Error('Invalid FeatureCollection json.');
        }
        var features = json.features.map(function (f) { return Feature_1.default.create(f); });
        return new FeatureCollection(features, json.id);
    };
    return FeatureCollection;
}());
exports.default = FeatureCollection;
